import request from '@/untils/request'
export default {
   // 订单列表
   orderList(params) {
    return request({
      url: "/ticket/orderInquire/FindOldOrder",
      methods: "post",
      params
    })   
  },
  // 订单详情 
  orderDetail(orderid) {
    return request({
      url: "/ticket/orderInquire/FindOrderDetails",
      methods: "post",
      params: {
        "orderid": orderid
      }
    })   
  },

  //支付接口  
//   getQrCode(orderid) {
//     return request({
//       url: "/bills/getQrCode",
//       methods: "post",
//       params: {
//         "orderId": orderid
//       }
//     })   
//   },
  //测试：扫码支付
  getPrepayId(orderid) {
        return request({
            url: "/wxPay/getPrepayId",
            methods: "post",
            params: {
                "orderId": orderid,
                "trade_type": "NATIVE"
            }
        })   
  },

  // 删除
  cancelOrder(orderid) {
    return request({
      url: "/ticket/order/cancelOrder",
      methods: "post",
      params: {
        "orderId": orderid
      }
    })   
  },

  // 退款
  refundOrder(orderid) {
    return request({
        url: "/ticket/order/refundPCOrder",
        methods: "post",
        params: {
            "orderId": orderid
        }
    })   
  },
  
  //查看二维码
  sendCode(orderid) {
    return request({
        url: "/ticket/order/send_code_img_req",
        methods: "post",
        params: {
            "orderId": orderid
        }
    })   
  },

};



// WEBPACK FOOTER //
// ./src/api/myOrder.js